import React, { useMemo } from "react";

import { AreaPricesCardStateProviderProps } from "./types";
import AreaPricesCard from "./AreaPricesCard";

const AreaPricesCardStateProvider: React.FC<AreaPricesCardStateProviderProps> = ({
  areaCode,
  areaName,
  lastChanged,
  prices,
  editable,
  loading = false,
  title,
  onPriceChange = () => {},
}) => {
  if (!prices?.length) return null;
  const memoizedPrices = useMemo(() => prices, []);
  const cardTitle =
    title ||
    `${editable ? "Set m" : "M"}y prices in ${areaCode} ${areaName} area`;

  return (
    <AreaPricesCard
      lastChanged={lastChanged}
      prices={prices || []}
      editable={editable || false}
      loading={loading}
      cardTitle={cardTitle}
      handleChange={onPriceChange}
      memoizedPrices={memoizedPrices}
    />
  );
};

export default AreaPricesCardStateProvider;
